import Navbar from "./Navbar";
import BottomNav from "./BottomNav";
import VerifyBanner from "./VerifyBanner";
import VerifyGate from "./VerifyGate";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AppShell({ children }) {
  const { user } = useAuth();
  const needsVerify = user && !user.email_verified && (user.auth_provider || "email") === "email" && user.role !== "admin";

  return (
    <div className="min-h-screen bg-su-bg text-su-text">
      <Navbar />
      {needsVerify ? (
        <main className="max-w-7xl mx-auto px-4 py-6 pb-28 md:pb-10"><VerifyGate /></main>
      ) : (
        <>
          <VerifyBanner />
          <main className="max-w-7xl mx-auto px-4 py-6 pb-28 md:pb-10">{children}</main>
        </>
      )}
      <footer className="max-w-7xl mx-auto px-4 pb-28 md:pb-8 pt-2 flex flex-wrap items-center justify-center gap-3 text-sm">
        <Link to="/faq" data-testid="shell-footer-faq" className="font-heading font-bold text-su-muted hover:text-su-primary transition-colors">FAQ</Link>
        <span className="text-su-border">·</span>
        <Link to="/terms" data-testid="shell-footer-terms" className="font-heading font-bold text-su-muted hover:text-su-primary transition-colors">Syarat & Ketentuan</Link>
        <span className="text-su-border">·</span>
        <Link to="/refund" data-testid="shell-footer-refund" className="font-heading font-bold text-su-muted hover:text-su-primary transition-colors">Kebijakan Refund</Link>
        <span className="text-su-border">·</span>
        <Link to="/contact" data-testid="shell-footer-contact" className="font-heading font-bold text-su-muted hover:text-su-primary transition-colors">Kontak</Link>
      </footer>
      {!needsVerify && <BottomNav />}
    </div>
  );
}
